import React, { useEffect, useState } from "react";

import styles from "./BalanceTopUp.module.scss";
import currencyIcon from "../../../../../assets/images/packages/Currency.svg";
import MainButton from "../../../../shared/button/MainButton";
import { BalanceTopUpType, BankCardType } from "../../../../../interface/site.interface";
import { BalanceServices } from "../../../../../services/balance.service";
import { BankCardsServices } from "../../../../../services/bankCards.service";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
import CardSelectModal from "../../../../shared/card-select-modal/CardSelectModal";
import PaymentStatusModal from "../../../../shared/payment-status-modal/PaymentStatusModal";
import NoCardsModal from "../../../../shared/no-cards-modal/NoCardsModal";

export default function BalanceTopUp({
  isModalOpen,
  setIsModalOpen,
  isSuccess,
  setIsSuccess,
  defaultAmount = "",
  myBalance,
}: BalanceTopUpType) {
  const [serviceBalance, setServiceBalance] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [cards, setCards] = useState<BankCardType[]>([]);
  const [isCardModalOpen, setIsCardModalOpen] = useState(false);
  const [isPaymentStatusOpen, setIsPaymentStatusOpen] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [isPaymentLoading, setIsPaymentLoading] = useState(false);
  const [isNoCardsModalOpen, setIsNoCardsModalOpen] = useState(false);
  const [isDirectPayLoading, setIsDirectPayLoading] = useState(false);

  const { data } = useSelector((state: RootState) => state.translationData);


  const handlePayClick = async () => {
    if (!serviceBalance) return;

    setIsLoading(true);
    try {
      const response = await BankCardsServices.getBankCards();
      const cardsList = response.data?.data || [];

      if (cardsList.length === 0) {
        setIsNoCardsModalOpen(true);
        return;
      }

      setCards(cardsList);
      setIsCardModalOpen(true);
    } catch (error) {
      console.error("Kartlar yuklenirken xeta:", error);
      setIsNoCardsModalOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCardSelect = async (cardId: number) => {
    setIsPaymentLoading(true);
    try {
      localStorage.setItem("lastBalanceAmount", serviceBalance);

      const response = await BalanceServices.PostBalance({
        amount: serviceBalance,
        card_id: cardId,
        payment_provider: "card",
      });

      if (response.data?.original?.case === "success" || response.data?.success) {
        setPaymentSuccess(true);
        setIsPaymentStatusOpen(true);
        if (setIsSuccess) setIsSuccess(true);
      } else {
        setPaymentSuccess(false);
        setIsPaymentStatusOpen(true);
        if (setIsSuccess) setIsSuccess(false);
      }
    } catch (error) {
      console.error("Odenis xetasi:", error);
      setPaymentSuccess(false);
      setIsPaymentStatusOpen(true);
      if (setIsSuccess) setIsSuccess(false);
    } finally {
      setIsPaymentLoading(false);
      setIsCardModalOpen(false);
    }
  };

  const handleDirectPayClick = async () => {
    if (!serviceBalance) return;

    setIsDirectPayLoading(true);
    try {
      localStorage.setItem("lastBalanceAmount", serviceBalance);

      const response = await BalanceServices.PostBalanceDirectPay({
        amount: serviceBalance,
      });

      const url = response.data?.url;
      if (url) {
        window.location.href = url;
      } else {
        setPaymentSuccess(false);
        setIsPaymentStatusOpen(true);
      }
    } catch (error) {
      setPaymentSuccess(false);
      setIsPaymentStatusOpen(true);
    } finally {
      setIsDirectPayLoading(false);
    }
  };

  const handlePashaClick = async () => {
    if (!serviceBalance) return;

    setIsLoading(true);
    try {
      localStorage.setItem("lastBalanceAmount", serviceBalance);

      const response = await BalanceServices.PostBalance({
        amount: serviceBalance,
        payment_provider: "pasha",
      });

      const original = response.data?.original;

      if (
        original?.case === "success" &&
        original?.content &&
        original?.content.startsWith("http")
      ) {
        window.location.href = original.content;
      } else if (original?.case === "success" || response.data?.success) {
        setPaymentSuccess(true);
        setIsPaymentStatusOpen(true);
        if (setIsSuccess) setIsSuccess(true);
      } else {
        setPaymentSuccess(false);
        setIsPaymentStatusOpen(true);
        if (setIsSuccess) setIsSuccess(false);
      }
    } catch (error) {
      setPaymentSuccess(false);
      setIsPaymentStatusOpen(true);
      if (setIsSuccess) setIsSuccess(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePaymentRedirect = () => {
    setIsPaymentStatusOpen(false);
    if (paymentSuccess) {
      window.location.reload();
    }
  };

  useEffect(() => {
    const lastAmount = localStorage.getItem("lastBalanceAmount");
    if (lastAmount) {
      setServiceBalance(lastAmount);
    } else if (defaultAmount) {
      setServiceBalance(String(defaultAmount));
    }
    return () => {
      if (!window.location.pathname.includes("my-balance")) {
        localStorage.removeItem("lastBalanceAmount");
      } else if (window.location.pathname.includes("payment")) {
        localStorage.removeItem("lastBalanceAmount");
      }
    };
  }, [defaultAmount]);

  useEffect(() => {
    localStorage.removeItem("lastBalanceAmount");
  }, []);

  return (
    <div className={styles.balance_top_up_container}>
      <div className={styles.increases_balance_container}>
        <div>
          <p className={styles.increases_balance_title}>
            {myBalance.get_page.add_balance}
          </p>

          <div className={styles.increases_balance_content}>
            <p className={styles.increases_balance_input_label}>
              {myBalance.get_page.amount}
            </p>

            <div className={styles.increases_balance_input_container}>
              <input
                type="number"
                name="amount"
                value={serviceBalance}
                onChange={(e) => {
                  setServiceBalance(e.target.value);
                  localStorage.setItem("lastBalanceAmount", e.target.value);
                }}
                placeholder={data?.auth_enter_amount}
              />
              <div className={styles.icon}>
                <img src={currencyIcon} alt="currency" />
              </div>
            </div>
          </div>
        </div>

        <div className={styles.payment_buttons}>
          <MainButton
            className={styles.pay_btn}
            text={isLoading ? "..." : data?.pay_by_card}
            onClick={handlePayClick}
            disabled={!serviceBalance || isLoading || isDirectPayLoading}
          />
          <button
            className={styles.direct_pay_btn}
            onClick={handleDirectPayClick}
            disabled={!serviceBalance || isLoading || isDirectPayLoading}
          >
            {isDirectPayLoading ? "..." : "Birbaşa ödə"}
          </button>
        </div>
      </div>

      <CardSelectModal
        isOpen={isCardModalOpen}
        onClose={() => setIsCardModalOpen(false)}
        onSelectCard={handleCardSelect}
        cards={cards}
        isLoading={isPaymentLoading}
        amount={serviceBalance}
        translationData={data}
      />

      <PaymentStatusModal
        isOpen={isPaymentStatusOpen}
        isSuccess={paymentSuccess}
        onClose={() => setIsPaymentStatusOpen(false)}
        onRedirect={handlePaymentRedirect}
        translationData={data}
      />

      <NoCardsModal
        isOpen={isNoCardsModalOpen}
        onClose={() => setIsNoCardsModalOpen(false)}
        translationData={data}
      />
    </div>
  );
}
